<template>
  <div class="">
    <label>Credit Card Details</label>
    <div ref="card" class="form-group"></div>
  </div>
</template>

<script>
export default {
  name: "Stripe",
  props: {
    isFilled: Boolean,
  },
  data() {
    return {
      spk:
        process.env.NODE_ENV === "production"
          ? "pk_live_1NOQOeCIB9gblvcUhjVZ9Dmi"
          : "pk_test_HiVfCOGJn7zayqtLZ06GUkKA",
      // : "pk_test_HiVfCOGJn7zayqtLZ06GUkKA", //Should we catch this from a request?
      stripe: undefined,
      card: undefined,
      msg: "Donate Here",
      payAmount: "$10.00",
      lockSubmit: false,
    };
  },
  mounted() {
    this.stripe = window.Stripe(this.spk);
    var elements = this.stripe.elements();
    let style = {
      base: {
        lineHeight: "1.5",
      },
      invalid: {
        // All of the error styles go inside of here.
      },
    };
    this.card = elements.create("card", { style });
    this.card.on("change", this.cardUpdated);
    this.card.mount(this.$refs.card);
  },
  methods: {
    cardUpdated(update) {
      console.log("update", update);
      if (update.complete !== this.sFilled) {
        this.$emit("update:isFilled", update.complete);
      }
    },
    async loadCard(userData) {
      return this.stripe.createPaymentMethod({
        type: "card",
        card: this.card,
        billing_details: {
          name: userData.name,
          email: userData.email,
          address: {
            city: userData.city,
            line1: userData.line1,
            postal_code: userData.zip,
            state: userData.state,
          },
        },
      });
    },
  },
};
</script>

<style>
.StripeElement {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.StripeElement--focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>
